import React, { useEffect } from "react";
import {
  getOddsByRunner,
  getUniversalCasinoPlExposureByRunner,
  GetUniversalLastTenResult,
} from "./genericFunctions";
import {
  getCasinoExposureAPI,
  getUniversalCasinoLastResultAPI,
  getUniversalCasinoOddsAPI,
} from "../../service/casino";
import { useParams } from "react-router-dom";
import { CARD_ARRAY } from "../casino/CasinoGeneric";

import toast from "react-hot-toast";
import GenericCasinoTimer from "../../components/GenericCasinoTimer";

export default function DTL() {
  const { id: GAME_ID } = useParams();
  const haveModule2 = GAME_ID?.includes("LUCKY_7_A");
  const haveCardSuit = GAME_ID?.includes("LUCKY_7_A");
  const [selected, setSelected] = React.useState("DRAGON");
  const [odds, setOdds] = React.useState({});
  const [lastResult, setLastResult] = React.useState({});
  const [exposure, setExposure] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [timer, setTimer] = React.useState(0);
  const [placeBetPayload, setPlaceBetPayload] = React.useState({
    amount: 0,
    back: 0,
    casinoGames: GAME_ID,
    marketId: "",
    runnerName: "",
    marketIdWithSelectionId: "",
    type: "back",
  });
  const roundIdRef = React.useRef();
  const getOdds = async () => {
    const { response } = await getUniversalCasinoOddsAPI(GAME_ID);
    setOdds(response);
  };
  const getLastResult = async () => {
    const { response } = await getUniversalCasinoLastResultAPI(GAME_ID);
    setLastResult(response);
  };
  const getExposure = async () => {
    const { response } = await getCasinoExposureAPI(roundIdRef.current);
    setExposure(response);
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [odds?.roundId]);
 
  React.useEffect(() => {
    getOdds();
    getLastResult();
    let interval = setInterval(() => {
      getOdds();
    }, 800);
    let interval2 = setInterval(() => {
      getLastResult();
    }, 5000);
    let interval3 = setInterval(() => {
      getExposure();
    }, 2000);
    return () => {
      clearInterval(interval);
      clearInterval(interval2);
      clearInterval(interval3);
    };
  }, []);
  const [showWinnerOverlay, setShowWinnerOverlay] = React.useState(false);

  // Function to check time condition
  const checkTimeCondition = () => {
    const timeA = new Date().getTime();
    const roundWinnerUpdatedAt = odds?.roundWinnerUpdatedAt;
    if (timeA < roundWinnerUpdatedAt + 3000 && timeA >= roundWinnerUpdatedAt) {
      setShowWinnerOverlay(true);
    } else {
      setShowWinnerOverlay(false);
    }
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);
    let timeCheckInterval = setInterval(checkTimeCondition, 100);

    return () => {
      clearInterval(interval);
      clearInterval(timeCheckInterval);
    };
  }, [odds?.roundId, odds?.roundWinnerUpdatedAt]);

  return (
    <app-dtl _nghost-ng-c2057369667="">
      <div
        style={{ overflowY: "scroll", height: "min-content" }}
        _ngcontent-ng-c2057369667=""
        style={{ overflowY: "hidden" }}
      >
        <div _ngcontent-ng-c2057369667="">
          <app-video-player
            _ngcontent-ng-c2057369667=""
            _nghost-ng-c595356512=""
          >
            <div _ngcontent-ng-c595356512="" className="videoPlayer">
              <video
                _ngcontent-ng-c595356512=""
                id="remoteVideo"
                width="100%"
                height="100%"
                autoplay=""
                playsinline=""
                muted=""
                style={{
                  background:
                    "black 50% / 48% 75% no-repeat  url(https://casino.queenexch.com/assets/loader.gif)",
                }}
              ></video>

              <div _ngcontent-ng-c595356512="" className="video-overlay">
                <div _ngcontent-ng-c595356512="">
                  <div
                    _ngcontent-ng-c595356512=""
                    className="round-id text-white"
                  >
                    RID: {odds?.roundId}
                  </div>

                  {odds?.playerCards?.map((player) => (
                    <div _ngcontent-ng-c595356512="">
                      <h3 _ngcontent-ng-c595356512="" className="text-white">
                        {player?.forPerson}
                      </h3>
                      <div _ngcontent-ng-c595356512="">
                        {player?.cards?.map((card) => (
                          <img
                            _ngcontent-ng-c595356512=""
                            src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                          />
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {showWinnerOverlay && (
                <div _ngcontent-ng-c595356512="" className="winnerOverlay">
                  <div
                    _ngcontent-ng-c595356512=""
                    className="mini-result-new active"
                  >
                    <span _ngcontent-ng-c595356512="">
                      {" "}
                      {odds?.roundWinner} win{" "}
                    </span>
                    {/**/}
                  </div>
                  <span
                    _ngcontent-ng-c595356512=""
                    style={{ position: "absolute" }}
                  >
                    <canvas
                      _ngcontent-ng-c595356512=""
                      width="100vw"
                      height="100vh"
                    />
                  </span>
                  {/**/}
                </div>
              )}

              <div _ngcontent-ng-c595356512="" className="timer-overlay">
                <GenericCasinoTimer
                  time={odds?.seconds}
                  status={odds?.status}
                />
              </div>
            </div>

            <div
              _ngcontent-ng-c595356512=""
              id="rulesModal"
              tabIndex={-1}
              aria-labelledby="exampleModalLabelaexampleModalLabela"
              aria-hidden="true"
              className="modal fade"
            >
              <div
                _ngcontent-ng-c595356512=""
                className="modal-dialog rules-wrap"
              >
                <div
                  _ngcontent-ng-c595356512=""
                  role="document"
                  id="rulesList___BV_modal_content_"
                  tabIndex={-1}
                  className="modal-content rules-content"
                >
                  <header
                    _ngcontent-ng-c595356512=""
                    id="rulesList___BV_modal_header_"
                    className="rules-wrap"
                  >
                    <a _ngcontent-ng-c595356512="">
                      <h3
                        _ngcontent-ng-c595356512=""
                        id="rulesList___BV_modal_title_"
                        data-bs-toggle="modal"
                        data-bs-target="#rulesModal"
                        className="modal-title"
                      >
                        {" "}
                        Rules
                      </h3>
                    </a>
                    <button
                      _ngcontent-ng-c595356512=""
                      type="button"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      className="close"
                    >
                      ×
                    </button>
                  </header>
                  <div
                    _ngcontent-ng-c595356512=""
                    id="rulesList___BV_modal_body_"
                    className="modal-body"
                  >
                    <div _ngcontent-ng-c595356512="" id="rulesBoxContainer" />
                  </div>
                  <div _ngcontent-ng-c595356512="">
                    <ul _ngcontent-ng-c595356512="" className="btn-wrap break">
                      <li _ngcontent-ng-c595356512="">
                        <a
                          _ngcontent-ng-c595356512=""
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          className="btnok"
                        >
                          OK
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </app-video-player>
        </div>
        <div
          _ngcontent-ng-c2057369667=""
          id="marketScroll"
          style={{ overflowY: "auto", height: 519 }}
          className="overflow-auto"
        >
          <div _ngcontent-ng-c2057369667="" className="main-container">
            <div _ngcontent-ng-c2057369667="" className="tab-con">
              <ul _ngcontent-ng-c2057369667="" className="nav nav-tabs">
                <li
                  onClick={() => setSelected("DRAGON")}
                  _ngcontent-ng-c2057369667=""
                  className="nav-item"
                >
                  <a
                    _ngcontent-ng-c2057369667=""
                    className={`nav-link ${
                      selected === "DRAGON" ? "active" : ""
                    }`}
                  >
                    Dragon
                  </a>
                </li>
                <li
                  onClick={() => setSelected("TIGER")}
                  _ngcontent-ng-c2057369667=""
                  className="nav-item"
                >
                  <a
                    _ngcontent-ng-c2057369667=""
                    className={`nav-link ${
                      selected === "TIGER" ? "active" : ""
                    }`}
                  >
                    Tiger
                  </a>
                </li>
                <li
                  onClick={() => setSelected("LION")}
                  _ngcontent-ng-c2057369667=""
                  className="nav-item"
                >
                  <a
                    _ngcontent-ng-c2057369667=""
                    className={`nav-link ${
                      selected === "LION" ? "active" : ""
                    }`}
                  >
                    Lion
                  </a>
                </li>
              </ul>
            </div>
            <table _ngcontent-ng-c2057369667="">
              <tbody>
                {[
                  {
                    haveCard: false,
                    dynamic: true,
                    name: "Winner",
                  },
                  {
                    haveCard: true,
                    cards: ["HEARTS", "DIAMONDS"],
                    name: "Red",
                  },
                  {
                    haveCard: true,
                    cards: ["CLUBS", "SPADES"],
                    name: "Black",
                  },
                  {
                    haveCard: false,

                    name: "Odd",
                  },
                  {
                    haveCard: false,

                    name: "Even",
                  },
                ]?.map((item) => (
                  <>
                    <tr _ngcontent-ng-c2057369667="" className="table-row">
                      <td _ngcontent-ng-c2057369667="" className="col">
                        {item?.haveCard ? (
                          <div
                            _ngcontent-ng-c2057369667=""
                            className="value-col"
                          >
                            <div _ngcontent-ng-c2057369667="" class="img-con">
                              {item?.cards?.map((card) => (
                                <img
                                  _ngcontent-ng-c2057369667=""
                                  src={`https://casino.queenexch.com/assets/andarBahar/${card}.png`}
                                  alt="cards-red"
                                />
                              ))}
                            </div>
                          </div>
                        ) : (
                          <div
                            _ngcontent-ng-c2057369667=""
                            className="value-col"
                          >
                            <div _ngcontent-ng-c2057369667="">
                              <b _ngcontent-ng-c2057369667="">{item?.name}</b>
                            </div>

                            <div _ngcontent-ng-c2057369667="">
                              <span _ngcontent-ng-c2057369667="">
                                {getUniversalCasinoPlExposureByRunner(
                                  exposure,
                                  item?.dynamic
                                    ? selected
                                    : selected + " " + item?.name
                                )}
                              </span>
                            </div>
                          </div>
                        )}
                      </td>
                      <td _ngcontent-ng-c2057369667="">
                        <div
                          _ngcontent-ng-c2057369667=""
                          className={`value ${
                            getOddsByRunner(
                              odds,
                              item?.dynamic
                                ? selected
                                : selected + " " + item?.name,
                              true
                            )?.status === "SUSPEND"
                              ? "suspended"
                              : ""
                          }`}
                        >
                          <b _ngcontent-ng-c2057369667="">
                            {getOddsByRunner(
                              odds,
                              item?.dynamic
                                ? selected
                                : selected + " " + item?.name
                            )}
                          </b>
                        </div>
                      </td>
                      <td
                        _ngcontent-ng-c2057369667=""
                        className="desk-value d-none-mbl"
                      >
                        <div
                          _ngcontent-ng-c2057369667=""
                          className="emptyvalue"
                        />
                      </td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>

            <div _ngcontent-ng-c2057369667="" className="second-sec-container">
              <div _ngcontent-ng-c2057369667="" className="txt-con">
                <div _ngcontent-ng-c2057369667="" className="txt">
                  <b _ngcontent-ng-c2057369667="">12</b>
                </div>
              </div>
              <div _ngcontent-ng-c2057369667="" className="card-container">
                {CARD_ARRAY?.map((card) => (
                  <div _ngcontent-ng-c2057369667="" className="card-image">
                    <div
                      _ngcontent-ng-c2057369667=""
                      className={odds?.status === "SUSPEND" ? "suspended" : ""}
                    >
                      <img
                        _ngcontent-ng-c2057369667=""
                        src={`https://casino.queenexch.com/assets/lucky7_cards/${card}.png`}
                      />
                    </div>
                    <div
                      _ngcontent-ng-c2057369667=""
                      className="ubook text-center m-t-5 text-success h-18"
                      style={{ width: "35px !important" }}
                    >
                      {getUniversalCasinoPlExposureByRunner(
                        exposure,
                        selected + " " + card
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <GetUniversalLastTenResult lastResult={lastResult} />
          </div>
        </div>
      </div>
    </app-dtl>
  );
}
